<script>
import $ from 'jquery';
import Inputmask from "inputmask";
import {KTApp} from '@/plugins/core/app';
import {userService} from '@/common/api.service';

export default {
    data() {
        return {
            form_data: {
                phone: null,
                code: null
            },
            changeUserPhoneStep: 'sendOtp',
            error_message: null
        }
    },
    mounted() {
        setTimeout(() => {
            Inputmask("0999-9999999").mask(document.getElementById("phone_number"));
        }, 100);
    },
    methods: {
        changePhoneNumber(event) {
            let form = $(event.target);
            let btn = $('#submit_btn');
            this.error_message = null;

            if (this.changeUserPhoneStep === 'sendOtp') {
                return this.getOtpCode(form, btn);
            }

            form.validate({
                ignore: ':hidden',
                rules: {
                    phone: {
                        required: true,
                    },
                    code: {
                        required: true,
                    }
                }
            });

            if (!form.valid()) {
                return;
            }

            KTApp.progress(btn)
            let params = {
                phone: this.form_data.phone.replace('-', ''),
                code: this.form_data.code
            }

            userService
                .verificationPhoneNumber(params)
                .then(({data}) => {
                    this.toastr.success(data.message)
                    this.changeUserPhoneStep = 'sendOtp';
                }).catch(({response}) => {
                form.validate().showErrors(response.data.data);
                this.error_message = response.data.message;
            }).finally(() => {
                KTApp.unprogress(btn);
            });


        },
        getOtpCode(form, btn) {
            form.validate({
                ignore: ':hidden',
                rules: {
                    phone: {
                        required: true,
                    },
                }
            });

            if (!form.valid()) {
                return;
            }

            KTApp.progress(btn)
            let params = {
                phone: this.form_data.phone.replace('-', '')
            }

            userService
                .changeUserPhoneNumber(params)
                .then(({data}) => {
                    this.toastr.success(data.message)
                    this.changeUserPhoneStep = null;
                }).catch(({response}) => {
                form.validate().showErrors(response.data.data);
                this.error_message = response.data.message;
            }).finally(() => {
                KTApp.unprogress(btn);
            });
        },
    }
}
</script>

<template>
    <div>
        <kt-panel>
            <kt-panel-body>
                <form @submit.prevent="changePhoneNumber">
                    <div class="row">
                        <div class="col-6 col-md-6">
                            <kt-form-group>
                                {{$t('label.change_phone_number')}}
                            </kt-form-group>
                        </div>
                        <div class=" col-6 col-md-6 my-2 row justify-content-end">
                            <button type="submit" id="submit_btn" class="btn btn-success btn-sm">{{$t('btn.edit')}}</button>
                        </div>

                    </div>
                    <div class="line-divider mb-4"></div>
                    <div class="alert alert-danger" v-if="this.error_message">{{ this.error_message }}</div>
                    <div class="row">
                        <div class="col-6 col-md-6" dir="ltr">
                            <label for="phone">{{$t('label.new_phone_number')}}</label>
                            <input type="text" v-model="form_data.phone" ref="phone" name="phone" id="phone_number" class="form-control">
                        </div>
                        <div class="col-6 col-md-6" v-if="changeUserPhoneStep !== 'sendOtp'">
                            <label for="code">{{$t('label.validation_code')}}}</label>
                            <input type="text" v-model="form_data.code" name="code" id="code" class="form-control">
                        </div>
                    </div>
                </form>
            </kt-panel-body>
        </kt-panel>
    </div>

</template>

<style scoped>

</style>